import _typeof from "@babel/runtime/helpers/typeof";
export var validatorExist = function validatorExist(validators, key) {
  if (_typeof(key) === 'symbol') return false;
  return typeof validators[key] !== 'undefined';
};